import { render, staticRenderFns } from "./equitySetting.vue?vue&type=template&id=37074d05&scoped=true&"
import script from "./equitySetting.vue?vue&type=script&lang=ts&"
export * from "./equitySetting.vue?vue&type=script&lang=ts&"
import style0 from "./equitySetting.vue?vue&type=style&index=0&id=37074d05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37074d05",
  null
  
)

export default component.exports